module.exports = __webpack_public_path__ + "img/couples-081.8aafb705.jpg";